import { defineSlotRecipe } from "@pandacss/dev";
import { numberInputAnatomy } from "@ark-ui/react";
import {
  baseInputTrigger,
  mediumInputTigger,
  smallInputTigger,
} from "./utils/inputTrigger";

//to be completed
export const aromaNumberInput = defineSlotRecipe({
  className: "aroma-number-input",
  jsx: ["NumberInput"],
  slots: [...numberInputAnatomy.keys(), "trigger"],
  base: {
    control: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      position: "relative",
      padding: "padding.0,5",
      borderWidth: "m",
      borderColor: {
        base: "border.neutral.bold",
        _focus: "border.brand-bold",
        _disabled: "background.neutral.disable.subtle",
      },
      bgColor: {
        base: "background.neutral.base.subtlest",
        _hover: "background.neutral.base.subtlest-hover",
        _disabled: "background.neutral.disable.subtle",
      },
      gap: "gap.1",
      textStyle: "paragraph.m.regular",
      color: {
        base: "content.neutral.base.bold",
        _disabled: "content.neutral.base.disable",
      },
      shadow: {
        _focus: "effect.focus-ring.brand",
      },
      cursor: {
        base: "unset",
        _disabled: "not-allowed",
      },
      _disabled: {
        _aromaticonChildren: {
          _required: {
            color: "content.neutral.base.disable",
          },
        },
      },
      _aromaticonChildren: {
        alignSelf: "center",
        fontSize: "{sizes.xs}",
        _required: {
          fontSize: "{sizes.4xs}",
          position: "absolute",
          bg: "background.neutral.base.subtlest",
          color: "content.neutral.base.subtlest",
          top: 0,
          right: 0,
          shadow: "0 0 0 2px {colors.background.neutral.base.subtlest}",
          borderRadius: "pill",
        },
      },
    },
    trigger: baseInputTrigger,

    input: {
      border: "none",
      outline: "none",
      textAlign: "center",
      flexGrow: 1,
      cursor: {
        base: "unset",
        _disabled: "not-allowed",
      },
    },
  },
  variants: {
    size: {
      small: {
        control: {
          height: "m",
          borderRadius: "s",
        },
        trigger: smallInputTigger,
      },
      medium: {
        control: {
          height: "xl",
          borderRadius: "l",
        },
        trigger: mediumInputTigger,
      },
    },
    reversed: {
      //whiteLabel theme only
      true: {
        control: {
          _withinWhiteLabelTheme: {
            bgColor: {
              base: "transparent",
              _hover: "background.neutral-on-brand.base.subtlest-hover",
              _focus: "background.brand.bold",
            },
            borderColor: {
              base: "border.neutral-on-brand.bold",
              _hover: "border.neutral-on-brand.bold-hover",
              _focus: "border.neutral-on-brand.bold",
            },
            color: "content.neutral.bold",
            _focus: {
              shadow: "effect.focus-ring.neutral",
            },
            _aromaticonChildren: {
              _required: {
                color: "content.neutral.bold",
                bgColor: "background.brand.bold",
                shadow: "0 0 0 2px {colors.background.brand.bold}",
              },
            },
          },
        },
        trigger: {
          _withinWhiteLabelTheme: {
            color: "content.neutral.bold",
            bgColor: {
              base: "transparent",
              _hover: "background.neutral-on-brand.base.subtle-hover",
            },
            _active: {
              borderColor: "content.neutral.bold",
            },
          },
        },
      },
    },
  },
  defaultVariants: {
    size: "small",
  },
});
